import React, { useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import LegalDoc from "../legalDoc/legalDoc";

const COMPANY_NAME = "Sin Fila";
const CONTACT_EMAIL = "hola@reservasinfila.com";
const LAST_UPDATED = "October 14, 2025";

const fill = (text = "") =>
	text.replace("{{COMPANY_NAME}}", COMPANY_NAME).replace("{{CONTACT_EMAIL}}", CONTACT_EMAIL);

const paragraphs = (section) =>
	Object.keys(section || {})
		.filter((key) => /^p\d+$/.test(key))
		.sort((a, b) => Number(a.slice(1)) - Number(b.slice(1)))
		.map((key) => fill(section[key]));

const RefundPolicy = () => {
	const { language } = useContext(CombinedContext);
	const t = translations[language].refund;

	const sections = [
		{ id: "platform-fees", heading: t.platformFees.heading, paragraphs: paragraphs(t.platformFees) },
		{ id: "eligibility", heading: t.eligibility.heading, list: t.eligibility.list },
		{ id: "mid-month", heading: t.midMonth.heading, paragraphs: paragraphs(t.midMonth) },
		{ id: "process", heading: t.process.heading, paragraphs: paragraphs(t.process) },
		{ id: "non-refundable", heading: t.nonRefundable.heading, list: t.nonRefundable.list },
		{ id: "changes", heading: t.changes.heading, paragraphs: [t.changes.text] },
		{ id: "contact", heading: t.contact.heading, footnote: fill(t.contact.text) },
	];

	return (
		<LegalDoc
			title={t.title}
			lastUpdatedLabel={t.lastUpdated}
			lastUpdatedValue={LAST_UPDATED}
			intro={paragraphs(t.intro)}
			sections={sections}
		/>
	);
};

export default RefundPolicy;
